import localforage from 'localforage';

const localforageClient = localforage.createInstance({
  name: 'OSG',
  version: 2,
});

export { localforageClient };
